import { composeEmail, renderEmailHtml } from './email-composer.js';
export const MISSION_PLACEHOLDERS = ['[Name]', '[Company]', '[Opportunity]', '[Personalisation paragraph]', '[Case studies]'];
export function missionScripts(mission) {
    if (mission.scripts?.length)
        return mission.scripts;
    const legacySubject = mission.strategy.scriptSubject || '';
    const legacyBody = mission.strategy.scriptBody || '';
    return legacySubject || legacyBody ? [{ id: 'legacy', name: 'Main Mission Pitch', audience: 'general', subject: legacySubject, body: legacyBody, caseStudyIds: mission.strategy.caseStudyIds || [] }] : [];
}
export function defaultMissionContactPlan(mission, contactId) {
    return mission.outreachPlan?.[contactId] || { selected: false, priority: 'normal', order: mission.contactIds.indexOf(contactId) };
}
export function selectedMissionContacts(mission) {
    const priority = { high: 0, normal: 1, later: 2 };
    return mission.contactIds.filter(id => mission.outreachPlan?.[id]?.selected).sort((a, b) => {
        const x = defaultMissionContactPlan(mission, a), y = defaultMissionContactPlan(mission, b);
        return priority[x.priority] - priority[y.priority] || x.order - y.order;
    });
}
export function suggestMissionScript(mission, contact) {
    const scripts = missionScripts(mission);
    const planned = mission.outreachPlan?.[contact.id];
    const chosen = scripts.find(script => script.id === planned?.scriptId);
    if (chosen)
        return chosen;
    const target = mission.targets.find(t => t.name.trim().toLowerCase() === contact.companyName.trim().toLowerCase());
    const audience = target?.role === 'agency-partner' ? 'agency' : target?.role === 'delivery-partner' ? 'delivery' : target?.role === 'potential-client' ? 'rights' : 'general';
    return scripts.find(s => s.audience === audience) || scripts.find(s => s.audience === 'general') || scripts[0];
}
const unsupported = /\[([^\]\n]{1,80})\]/g;
/** The same content generator is used by Mission preview and Prepare. */
export function renderMissionEmail(input) {
    const { script, contact, opportunityName, caseStudies, personalisation = '', outreachUrl } = input;
    const cases = script.caseStudyIds.map(id => caseStudies.find(c => c.id === id && c.active !== false)).filter((c) => !!c).slice(0, 3);
    const replace = (text) => String(text || '')
        .replace(/\{\{(?:first_name|firstName)\}\}/gi, '[Name]')
        .replace(/\{\{company\}\}/gi, '[Company]')
        .replace(/\{\{opportunity\}\}/gi, '[Opportunity]')
        .replace(/\[Company\]/gi, contact.companyName)
        .replace(/\[Opportunity\]/gi, opportunityName)
        .replace(/\[Name\]/gi, contact.firstName || 'there');
    const template = { id: 'mission-preview', ownerUid: '', createdAt: '', updatedAt: '', key: 'mission', name: script.name, subject: replace(script.subject), body: replace(script.body), version: 1, active: true };
    const generated = composeEmail({ template, firstName: contact.firstName, personalisation, caseStudies: cases, opportunityName, outreachUrl });
    const subject = generated.subject.trim();
    const body = generated.body;
    const unresolved = [...new Set([...subject.matchAll(unsupported), ...body.matchAll(unsupported)].map(m => m[0]))];
    if (/\[Personalisation paragraph\]/i.test(script.body) && !personalisation.trim())
        unresolved.push('[Personalisation paragraph]');
    if (/\[Case studies\]/i.test(script.body) && !cases.length)
        unresolved.push('[Case studies]');
    return { subject, body, html: renderEmailHtml(body, cases), unresolved: [...new Set(unresolved)], cases };
}
